import i18n
	from '../i18n/i18n'

class Music {
	constructor() {
		this.language = i18n.language.substr(0, 2)
		this.characters = [];
		const languages = {
			de: require('../data/de/music.json'),
			en: require('../data/en/music.json')
		};
		this.music_json = languages[this.language];
	}

	getCategories = () => {
		let categories = {}

		categories["music_full_notes"] = {"title": i18n.t('music.music_full_notes')}
		categories["music_alterated_sharp_notes"] = {"title": i18n.t('music.music_alterated_sharp_notes')}
		categories["music_alterated_flat_notes"] = {"title": i18n.t('music.music_alterated_flat_notes')}

		for (let category in this.music_json.systems.music.categories) {
			categories[category] = this.music_json.systems.music.categories[category]
		}
		delete categories.notes
		return categories;
	}

	getNotes(alteration, sharp = true) {
		let notes = {}
		if (alteration) {
			if (sharp) {
				notes = this.music_json.systems.music.categories.notes.alteration_sharp;
			} else {
				notes = this.music_json.systems.music.categories.notes.alteration_flat;
			}
		} else {
			notes = this.music_json.systems.music.categories.notes.natural_note;
		}
		return notes;
	}

	getCharactersByCategory(category) {
		var result = {};
		for (let key in this.music_json.systems.music.categories) {
			if (key === category.toString() && key) {
				let characterList = this.music_json.systems.music.categories[key];
				for (let key2 in characterList.content) {
					if (category === "key_signature") {
						characterList.content[key2].title = characterList.content[key2].major + " " + i18n.t('music.major') + ", " + characterList.content[key2].minor + " " + i18n.t('music.minor');
					}
					result[key2] = characterList.content[key2];
				}
			}
		}
		return result;
	}

	getNotesWithPitch(pitch, alteration, sharp = true) {
		var result = {};
		var pitch_json = {};
		if (alteration) {
			if (sharp) {
				pitch_json = this.music_json.systems.music.categories.notes.alteration_sharp[pitch];
			} else {
				pitch_json = this.music_json.systems.music.categories.notes.alteration_flat[pitch];
			}
		} else {
			pitch_json = this.music_json.systems.music.categories.notes.natural_note[pitch];
		}
		let length_json = this.music_json.systems.music.categories.notes.length;
		for (let length in length_json) {
			var entry = {};
			entry.title = length_json[length].title2 + " " + pitch_json.title;
			entry.dots = [...pitch_json.dots]
			if (alteration) {
				entry.dots[1] = entry.dots[1] + length_json[length].dotsInc;
			} else {
				entry.dots[0] = entry.dots[0] + length_json[length].dotsInc;
			}
			result[length] = entry;
		}
		return result;
	}
}

export default Music;
